<div [ngClass]="[currentHintTileConfig?.isDashboardTile ? 'dashboard-tile' : 're-bg-white re-px-20 re-py-30 md:re-p-45',
                 'border-' + currentHintTileConfig?.borderTopColor]">
  <section
    class="alert__container"
    [attr.aria-labelledby]="currentHintTileConfig?.accessibilityLabel ? ariaHeadingId : null"
    [attr.aria-label]="!currentHintTileConfig?.accessibilityLabel ? currentHintTileConfig?.title : null"
    [attr.role]="currentHintTileConfig?.accessibilityRole || null"
  >
    @if(currentHintTileConfig?.accessibilityLabel) {
      <h2 class="screenreader-only" [id]="ariaHeadingId">
        {{ currentHintTileConfig?.accessibilityLabel }}
      </h2>
    }

    <div class="re-flex re-flex-col md:re-flex-row">
      <div class="re-w-40 re-h-40 re-mr-20 re-mb-10 re-self-center re-flex-shrink-0 re-relative
                  md:re-mb-0 md:re-self-start md:re-inline-block">
        <svg-icon [src]="currentHintTileConfig?.iconPath"></svg-icon>
        @if (currentHintTileConfig?.iconWithBadge) {
          <div class="badge__container">
            <svg-icon src="assets/icons/badge.svg"></svg-icon>
          </div>
        }
      </div>
      <div class="re-flex-col">
        @if (currentHintTileConfig?.title) {
          <div class="bold">{{currentHintTileConfig?.title}}</div>
        }
        <div [innerHTML]="currentHintTileConfig?.text"></div>
        @if (currentHintTileConfig?.linkType !== '') {
          <div class="re-mt-10">
            @if (currentHintTileConfig?.linkPath && currentHintTileConfig?.linkType === 'texticon') {
              <bdo-text-icon
                [iconPosition]="'right'"
                [text]="currentHintTileConfig?.linkText"
                (itemClicked)="toTarget()"
              ></bdo-text-icon>
            }
            @if (currentHintTileConfig?.linkPath && (currentHintTileConfig?.linkType === 'primaryButton' || currentHintTileConfig?.linkType === 'secondaryButton')) {
              <button
                class="re-button-small re-block"
                [ngClass]="currentHintTileConfig?.linkType === 'primaryButton' ? 're-primary' : 're-secondary'"
                (click)="toTarget()"
                >
                {{currentHintTileConfig?.linkText}}
              </button>
            }
            @if (!currentHintTileConfig?.linkPath) {
              <button
                class="re-button-small re-block"
                [ngClass]="currentHintTileConfig?.linkType === 'primaryButton' ? 're-primary' : 're-secondary'"
                (click)="tileClicked.emit()"
                >
                {{ currentHintTileConfig?.linkText }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </section>
</div>
